module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/staff5-1826b7f27713661fddd264b46e0e8bf8.jpg";